import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorkReportPhotosApi extends ApiModule {
    constructor() {
        super(ModulesMap.WORK_REPORT_PHOTOS, {
            entity: 'work_report_photos',
        })
    }
}
